<fgb-banner [pageTitle]="'games.banner.title' | translate" />
<fgb-page-header [pageTitle]="'games.banner.title'" [backButtonLink]="'/'" />

<div class="container mt-lg-3">
  <div class="game-container-sections animate-in delay-1">
    <div>
      <img [src]="'games/trivia.jpg' | contentAssetImage" />
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.trivia' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.trivia.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/quiz'">
          <div class="btn btn-secondary">{{ 'games.page.trivia.play' | translate }}</div>
        </div>
      </div>
    </div>

    <div>
      <img [src]="'games/polls.jpg' | contentAssetImage" />
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.polls' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.polls.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/polls'">
          <div class="btn btn-secondary">{{ 'games.page.polls.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="game-container-sections mt-4 animate-in delay-2">
    <div>
      <img [src]="'games/predictor.jpg' | contentAssetImage" />
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.predictor' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.predictor.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/predictor'">
          <div class="btn btn-secondary">{{ 'games.page.predictor.play' | translate }}</div>
        </div>
      </div>
    </div>

    <div>
      <img [src]="'games/pickaplayer.jpg' | contentAssetImage" />
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.pap' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.pap.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/pickaplayer'">
          <div class="btn btn-secondary">{{ 'games.page.pap.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
